import { useEffect, CSSProperties, useState } from "react";

const getCssProperties = (header: any) => {
    const styles = {};

    if (header?.backgroundColor) {
        styles["--header-background-color"] = header.backgroundColor;
    }

    if (header?.burgerColor) {
        styles["--burger-color"] = header.burgerColor;
    }

    if (header?.overlayBackgroundColor) {
        styles["--menu-overlay-background-color"] = header.overlayBackgroundColor;
    }

    if (header?.overlayAnchorColor) {
        styles["--menu-overlay-anchor-color"] = header.overlayAnchorColor;
    }

    if (header?.overlayBorderColor) {
        styles["--menu-overlay-border-color"] = header.overlayBorderColor;
    }

    if (header?.overlayCloseColor) {
        styles["--menu-overlay-close-color"] = header.overlayCloseColor;
    }

    return styles;
};

export default (header?: any): any => {
    const [result, setResult] = useState<CSSProperties>(getCssProperties(header));

    useEffect(() => {
        setResult(getCssProperties(header));
    }, [header]);

    return result;
};